import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProjectsPage from './pages/ProjectsPage';
import ProjectForm from './components/ProjectForm';
import ProjectDetails from './components/ProjectDetails';

const Projects = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/list" />} />
      <Route path="/list" element={<ProjectsPage />} />
      <Route path="/new" element={<Navigate to="/create" />} />
      <Route path="/create" element={<ProjectForm />} />
      <Route path="/:id" element={<ProjectDetails />} />
      <Route path="/:id/edit" element={<ProjectForm />} />
    </Routes>
  );
};

export default Projects;